import React from "react"
import VideoModal from "../../components/VideoModal/VideoModal"
import { SprintsRest } from "../../services/sprints/sprints-rest-interface"
import { getNofSprintQuestions, getSprintInfo } from "./utils"
import FeedbackView, { ISprintFeedback } from "./FeedbackView"

export default function SprintQuestionResults({testId, answers}) {
    let [questions, setQuestions] = React.useState<any[] | undefined>()
    let [loading, setLoading] = React.useState(false)
    let [error, setError] = React.useState("")
    let [videoId, setVideoId] = React.useState("")
    let [feedback, setFeedback] = React.useState<ISprintFeedback | undefined>()
    let mounted = React.useRef(true)

    let {subject, sprint} = getSprintInfo(testId)
    let nofQuestions = getNofSprintQuestions(subject, sprint)
    let filledAnswers = (answers || []).slice()
    for (let questionNumber = 1; questionNumber <= nofQuestions; questionNumber++) {
        if (!filledAnswers.some(answer => answer.questionNumber === questionNumber)) {
            filledAnswers.push({questionNumber, correct: false, incomplete: true})
        }
    }

    React.useEffect(() => () => { mounted.current = false }, [])

    async function showExplanation(questionNumber: number) {
        setLoading(true)
        setError("")
        try {
            let sprintQuestions = questions
            
            if (!sprintQuestions) {
                let fullSprint = await SprintsRest.getFullSprintWithUserAnswers(testId)
                sprintQuestions = fullSprint.timedSprint.questions
                if (!mounted.current) return
                setQuestions(sprintQuestions)
            }
            
            let question = (sprintQuestions || []).find(q => q.questionNumber === questionNumber)

            if (question && question.videoId && String(question.videoId) !== "?") {
                let {questionNumber, videoId, correctAnswer} = question
                let foundUserAnswer = filledAnswers.find(fa => fa.questionNumber === questionNumber)

                if (foundUserAnswer) {
                    setFeedback({questionNumber, correctAnswer, userSubmittedAnswer: foundUserAnswer.userSubmittedAnswer})
                }
                else {
                    setFeedback(undefined)
                }
                
                setVideoId(String(videoId))
            } else {
                setError(`No explanation video is available for Q${questionNumber}.`)
            }
        } catch (error) {
            if (mounted.current) setError("Unable to load the explanation video. Please click the question to try again.")
        } finally {
            if (mounted.current) setLoading(false)
        }
    }

    return (
        <>
            <div className="sprint-question-results">
                {filledAnswers.sort((a, b) => a.questionNumber - b.questionNumber).map(answer => {
                    let correct = typeof answer.correct === "boolean"
                        ? answer.correct
                        : !!answer.userSubmittedAnswer && answer.userSubmittedAnswer !== "?" && answer.userSubmittedAnswer === answer.correctAnswer
                    return (
                        <button
                            type="button"
                            className="sprint-question-result"
                            key={answer.questionNumber}
                            disabled={loading}
                            title={`Watch explanation for Q${answer.questionNumber}`}
                            onClick={() => showExplanation(answer.questionNumber)}
                        >
                            <span>Q{answer.questionNumber}</span> {answer.incomplete ? (
                                <span className="icon-round-border" role="img" aria-label="Incomplete" />
                            ) : (
                                <img
                                    src={`/assets/images/icons/v2/ico-answer-status-${correct ? "correct" : "incorrect"}.svg`}
                                    alt={correct ? "Correct" : "Incorrect"}
                                />
                            )}
                        </button>
                    )
                })}
            </div>
            {error && <div role="alert">{error}</div>}
            <SprintExplanationWithFeedbackView 
                videoId={videoId} 
                feedback={feedback} 
                onClose={() => setVideoId("")} 
            />
        </>
    )
}

//--- Helpers ---
function SprintExplanationWithFeedbackView(props) {
    let {videoId, feedback, onClose} = props

    return (
        <div>
            <VideoModal 
                videoId={videoId} 
                show={!!videoId} 
                onClose={onClose} 
                info={feedback && <FeedbackView feedback={feedback} />}
            />
        </div>
    )
}
